import { render } from "./WeekCalendar.vue?vue&type=template&id=6d2bb7e1"
import script from "./WeekCalendar.vue?vue&type=script&lang=js"
export * from "./WeekCalendar.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__